import { render, staticRenderFns } from "./ForgetPasswordV3.vue?vue&type=template&id=28962322&"
import script from "./ForgetPasswordV3.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports